export class TransacaoUpdated {
    id:string;
    valor:string;
    taxa:string;
    tipo_pagamento:string;
    status:string;
    created_at:Date;
    updated_at:Date;
    bandeira:string;
    primeiros_quatro_digitos:string;
    parcelas:string;
    portador_cartao:string;
    validade_cartao:string;
    vendedor:string;
    plano:string;
    transacao_numero_serial:string;
    vendedor_nome:string;
    transacao_taxa:any;
    sob_suspeita:boolean;
    externo_id:string;
    taxa_zoop?: string;
    taxa_medicinae?: string;

    constructor(
            id?:string,
            valor?:string,
            taxa?:string,
            tipo_pagamento?:string,
            status?:string,
            created_at?:Date,
            updated_at?:Date,
            primeiros_quatro_digitos?:string,
            parcelas?:string,
            bandeira?:string,
            portador_cartao?:string,
            validade_cartao?:string,
            vendedor?:string,
            plano?:string,
            transacao_numero_serial?:string,
            vendedor_nome?:string,
            transacao_taxa?:string,
            sob_suspeita?:boolean,
            externo_id?:string
        ) {
        this.id = id;
        this.valor = valor;
        this.taxa = taxa;
        this.tipo_pagamento = tipo_pagamento;
        this.status = status;
        this.created_at = new Date(created_at);
        this.updated_at = new Date(updated_at);
        this.primeiros_quatro_digitos = primeiros_quatro_digitos;
        this.parcelas = parcelas;
        this.bandeira = bandeira;
        this.portador_cartao = portador_cartao;
        this.validade_cartao = validade_cartao;
        this.vendedor = vendedor;
        this.plano = plano;
        this.vendedor_nome = vendedor_nome;
        this.transacao_numero_serial = transacao_numero_serial;
        this.transacao_taxa = transacao_taxa;
        this.sob_suspeita = sob_suspeita;
        this.externo_id = externo_id;
    }
}
